// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ou-0";
export var buttonContainer = "_ou-3";
export var cancelButton = "_ou-4";
export var headerSection = "_ou-6";
export var headerTitle = "_ou-9";
export var messageSideLeft = "_ou-1";
export var messageSideRight = "_ou-2";
export var orderNumberContainer = "_ou-7";
export var orderNumberLabel = "_ou-8";
export var submitButton = "_ou-5";